var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"return-goods-box"},[_c('ywhz-title-style-card',{attrs:{"title":_vm.$t('about.returnGoods.title'),"subtitle":"SERVICE STATEMENT"}}),_c('div',{staticClass:"layout-width layout-r",attrs:{"id":"articlee"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }